var i = { exports: {} }, l = function(r) {
  return !r || typeof r == "string" ? !1 : r instanceof Array || Array.isArray(r) || r.length >= 0 && (r.splice instanceof Function || Object.getOwnPropertyDescriptor(r, r.length - 1) && r.constructor.name !== "String");
}, p = l, o = Array.prototype.concat, u = Array.prototype.slice, a = i.exports = function(r) {
  for (var t = [], n = 0, c = r.length; n < c; n++) {
    var s = r[n];
    p(s) ? t = o.call(t, u.call(s)) : t.push(s);
  }
  return t;
};
a.wrap = function(e) {
  return function() {
    return e(a(arguments));
  };
};
var y = i.exports;
export {
  y as s
};
